// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".author-about__wrapper[data-v-332859c0]{margin-top:5px}@media (max-width:767px){.author-about__wrapper[data-v-332859c0]{margin-top:20px}}.author-about__wrapper .author-about[data-v-332859c0]{position:relative;-webkit-transition:.3s;-o-transition:.3s;transition:.3s;white-space:pre-wrap;max-width:850px}", ""]);
// Exports
module.exports = exports;
